import React from "react";

function NotFound(props) {
  return <h1>Error 404. Page Not Found!</h1>;
}

export default NotFound;
